import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";

import { NotificationModal } from "@/shared/common/InfoPopup/NotificationModal";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";

import { usePacks } from "../Packs/usePacks";
import { createState } from "@/global/store/zustand_store";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";

export const usePacksSelectionLossModal = createState({
  isOpen: false,
  packId: 0,
});

export const ConfirmEventSelectionLossModal: FC = () => {
  const modalState = usePacksSelectionLossModal();
  const { sm } = useCssMediaQuery("down");
  const {
    selectedPack,
    isPacksEnabled,
    handleSelectPack,
    progressBarPackText,
    confirmEventSelectionLossTitle,
  } = usePacks();

  function handleClickContinue() {
    if (!isPacksEnabled || !selectedPack?.selected) return;
    modalState.set({ isOpen: false });
    handleSelectPack(modalState.packId);
  }

  function handleClickCancel() {
    modalState.set({ isOpen: false });
  }

  if (!isPacksEnabled) return null;

  return (
    <NotificationModal
      hideTitleIcon
      hidePrimaryButton
      hideSecondaryButton
      title={confirmEventSelectionLossTitle}
      isOpen={modalState.isOpen}
      onClose={() => modalState.reset()}
      paperProps={{ style: { marginLeft: 2, marginRight: 2 } }}
      renderBody={() => (
        <Box>
          <Box p={sm ? 2 : 3}>
            <Stack direction="column">
              <Typography variant="body1">
                You&apos;re about to downgrade your {progressBarPackText}. This
                will cause you to lose your current event selections.
              </Typography>
              <br />
              <Typography variant="body1">
                Are you sure you want to continue?
              </Typography>
            </Stack>
          </Box>
        </Box>
      )}
      renderFooter={() => {
        return (
          <Stack
            py={2}
            px={2}
            gap={2}
            width={"100%"}
            justifyContent={"flex-end"}
            direction={"row"}
          >
            <ModalActionButton
              size="small"
              variant="secondary"
              onClick={handleClickCancel}
              style={{
                width: sm ? "fit-content" : "180px",
                fontWeight: 600,
                borderRadius: 99,
              }}
            >
              Cancel
            </ModalActionButton>

            <ModalActionButton
              size="small"
              variant="primary"
              onClick={handleClickContinue}
              style={{
                width: sm ? "fit-content" : "180px",
                fontWeight: 600,
                borderRadius: 99,
              }}
            >
              Continue
            </ModalActionButton>
          </Stack>
        );
      }}
    />
  );
};
